export { TextCardGrid, type TextCardGridProps } from "./TextCardGrid";
